import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Col, Modal, Row, Select } from "antd";
import 'antd/lib/modal/style/css';
import {Field, reduxForm} from "redux-form";
import {  CreateCheckbox,  CreatePasswordField,  CreateSelectField,  CreateTextField} from "../../helpers/InputCreator";
import {required} from "../../helpers/validations";
import {numberNormalizer} from "../../helpers/normalizers";
import languages from "../../language/languages";
import _ from 'lodash';
import {LockOutlined} from "@ant-design/icons";

class AdminConfigurationsModal extends React.Component {

  componentDidMount() {
    this.props.initialize(_.pick(this.props.entry, ['paramName', 'paramValue']));
  }

  renderField() {
    if(this.props.entry.type === 1) {
      return (
          <Field label={languages[this.props.language].value_column}
                 name="paramValue"
                 size={'large'}
                 className={'mb-10'}
                 component={CreateSelectField}
                 placeholder={languages[this.props.language].value_column}
                 validate={this.props.entry.mandatory ? [required] : []}
                 maxLength={this.props.entry.maxLength}
                 hasFeedback>
            {this.props.entry.paramValues?this.props.entry.paramValues.map(item => <Select.Option value={item}>{item}</Select.Option>):''}
          </Field>
      );
    } else if(this.props.entry.type === 0) {
      return (
          <Field label={languages[this.props.language].value_column}
                 name="paramValue"
                 size={'large'}
                 className={'mb-10'}
                 component={CreateTextField}
                 placeholder={languages[this.props.language].value_column}
                 validate={this.props.entry.mandatory ? [required] : []}
                 normalize={this.props.entry.number?numberNormalizer:''}
                 maxLength={this.props.entry.maxLength}
                 hasFeedback/>
          );
    } else if(this.props.entry.type === 3) {
      return (
          <Field label={languages[this.props.language].value_column}
                 name="paramValue"
                 size={'large'}
                 className={'mb-10'}
                 component={CreateCheckbox}
                 placeholder={languages[this.props.language].value_column}
                 hasFeedback/>
      );
    } else if(this.props.entry.type === 2) {
      return (
          <Field label={languages[this.props.language].value_column}
                 name="paramValue"
                 maxLength={this.props.entry.maxLength}
                 size={'large'}
                 className={'mb-10'}
                 prefix={<LockOutlined className={'icon-font'} />}
                 component={CreatePasswordField}
                 placeholder={languages[this.props.language].value_column}
                 validate={this.props.entry.required ? [required] : []}
                 hasFeedback/>
      );
    }
  }

  render() {
    return (
      <Modal
        visible={this.props.modalType !== null} width={720} {...this.props.modalProps}>
          <Form onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Field label={languages[this.props.language].name_column}
                       name="paramName"
                       size={'large'}
                       className={'mb-10'}
                       component={CreateTextField}
                       disabled={true}
                       placeholder={languages[this.props.language].name_column}
                       hasFeedback/>
              </Col>
              <Col className={'netcoConfig'} xs={24} md={12}>
                {this.renderField()}
              </Col>
            </Row>
            <Row>
              <Button className={'float-right'} htmlType={'submit'} type={'primary'}>{this.props.btn}</Button>
            </Row>
          </Form>
      </Modal>
    )
  }

}

export default reduxForm({form: 'admin_configurations_form'})(AdminConfigurationsModal);
